// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PasswordVerification-root-O9FHs {
  padding-left: 15px;
  padding-right: 15px;
}

.PasswordVerification-container-njMG4 {
  margin: 0 auto;
  padding: 60px 0px;
  max-width: 500px;
}

@media screen and (max-width: 1200px) {
  .PasswordVerification-root-O9FHs {
    padding-top: 80px;
  }
}`, "",{"version":3,"sources":["webpack://./src/routes/passwordVerification/PasswordVerification.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".root {\n  padding-left: 15px;\n  padding-right: 15px;\n}\n\n.container {\n  margin: 0 auto;\n  padding: 60px 0px;\n  max-width: 500px;\n}\n\n@media screen and (max-width: 1200px) {\n  .root {\n    padding-top: 80px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `PasswordVerification-root-O9FHs`,
	"container": `PasswordVerification-container-njMG4`
};
module.exports = ___CSS_LOADER_EXPORT___;
